import AssociatedObjectsCardSdk from 'card-associated-objects-lib/AssociatedObjectsCardSdk';
import AssociatedObjectsCard from 'card-associated-objects-lib/AssociatedObjectsCard';
import { getLoadingComponentProps as getLoadingComponentPropsAOC } from 'card-associated-objects-lib/localStorage/skeletonState/getLoadingComponentProps';
import PropertiesCard from 'card-properties-lib/sdk/PropertiesCard';
import { buildGlobalCrmCardRegistry } from 'crm-cards-global-registry/buildGlobalCrmCardRegistry';
import catchupCardTranslations from 'i2l?mode=lazy!ai-catchup-cards-lib/lang/en.lyaml';
import { DEFAULT_LOADING_COMPONENT_PROPS, TEXT_LIST } from 'crm-cards-sdk/constants/LoadingComponentProps';
import RecordTimelineCard from '../middlePane/RecordTimelineCard';
import { getGates } from 'quartz-core/framework/auth/app';
import { ASSOCIATION_CARD_REDESIGN, CATCHUP_CARDS, DEPRECATE_LEGACY_TIMELINE } from '../constants/gates';
let registry;
const RegistryOverridesMap = {
  PROPERTIES_V3: {
    CardComponent: PropertiesCard,
    lazyLoadedTranslations: undefined,
    getLoadingComponentProps: cardData => {
      return [{
        type: TEXT_LIST,
        count: cardData.configuration.propertyNames.length
      }];
    }
  },
  ASSOCIATION_V3: {
    CardComponent: AssociatedObjectsCardSdk,
    lazyLoadedTranslations: undefined,
    getLoadingComponentProps: (cardData, cardLocationContext) => {
      return getLoadingComponentPropsAOC(cardData, cardLocationContext);
    }
  }
};
const RegistryOverridesMapAssociationRedesign = {
  PROPERTIES_V3: {
    CardComponent: PropertiesCard,
    lazyLoadedTranslations: undefined,
    getLoadingComponentProps: cardData => {
      return [{
        type: TEXT_LIST,
        count: cardData.configuration.propertyNames.length
      }];
    }
  },
  ASSOCIATION_V3: {
    CardComponent: AssociatedObjectsCard,
    lazyLoadedTranslations: undefined,
    getLoadingComponentProps: (cardData, cardLocationContext) => {
      return getLoadingComponentPropsAOC(cardData, cardLocationContext);
    }
  }
};
const CatchupCardsRegistryMap = {
  CUSTOMER_TIDBITS: {
    cardComponentLoader: () => import('ai-catchup-cards-lib/customer-tidbits/CustomerTidbitsCard'),
    lazyLoadedTranslations: catchupCardTranslations,
    loadingComponentProps: DEFAULT_LOADING_COMPONENT_PROPS
  },
  CHALLENGES_PAIN_POINTS: {
    cardComponentLoader: () => import('ai-catchup-cards-lib/challenges-pain-points/ChallengesPainPointsCard'),
    lazyLoadedTranslations: catchupCardTranslations,
    loadingComponentProps: DEFAULT_LOADING_COMPONENT_PROPS
  },
  FEATURED_DEAL: {
    cardComponentLoader: () => import('ai-catchup-cards-lib/featured-deal/FeaturedDealCard'),
    lazyLoadedTranslations: catchupCardTranslations,
    loadingComponentProps: DEFAULT_LOADING_COMPONENT_PROPS
  },
  FEATURED_TICKET: {
    cardComponentLoader: () => import('ai-catchup-cards-lib/featured-ticket/FeaturedTicketCard'),
    lazyLoadedTranslations: catchupCardTranslations,
    loadingComponentProps: DEFAULT_LOADING_COMPONENT_PROPS
  },
  FEATURED_CONTACT: {
    cardComponentLoader: () => import('ai-catchup-cards-lib/featured-contact/FeaturedContactCard'),
    lazyLoadedTranslations: catchupCardTranslations,
    loadingComponentProps: DEFAULT_LOADING_COMPONENT_PROPS
  },
  SENTIMENT: {
    cardComponentLoader: () => import('ai-catchup-cards-lib/sentiment/SentimentCard'),
    lazyLoadedTranslations: catchupCardTranslations,
    loadingComponentProps: DEFAULT_LOADING_COMPONENT_PROPS
  },
  COMPANY_DESCRIPTION: {
    cardComponentLoader: () => import('ai-catchup-cards-lib/company-description/CompanyDescriptionCard'),
    lazyLoadedTranslations: catchupCardTranslations,
    loadingComponentProps: DEFAULT_LOADING_COMPONENT_PROPS
  },
  RECENT_INTERACTIONS: {
    cardComponentLoader: () => import('ai-catchup-cards-lib/recent-interactions/RecentInteractionsCard'),
    lazyLoadedTranslations: catchupCardTranslations,
    loadingComponentProps: DEFAULT_LOADING_COMPONENT_PROPS
  },
  FORMATTING_ISSUES: {
    cardComponentLoader: () => import('ai-catchup-cards-lib/formatting-issues/FormattingIssuesCard'),
    lazyLoadedTranslations: catchupCardTranslations,
    loadingComponentProps: DEFAULT_LOADING_COMPONENT_PROPS
  },
  MISSING_PROPERTIES: {
    cardComponentLoader: () => import('ai-catchup-cards-lib/missing-properties/MissingPropertiesCard'),
    lazyLoadedTranslations: catchupCardTranslations,
    loadingComponentProps: DEFAULT_LOADING_COMPONENT_PROPS
  },
  DUPLICATE_RECORDS: {
    cardComponentLoader: () => import('ai-catchup-cards-lib/duplicate-records/DuplicateRecordsCard'),
    lazyLoadedTranslations: catchupCardTranslations,
    loadingComponentProps: DEFAULT_LOADING_COMPONENT_PROPS
  }
};
export const getCardRegistry = () => {
  const isUngatedForAssociationCardRedesign = getGates().has(ASSOCIATION_CARD_REDESIGN);
  const isUngatedForCatchupCards = getGates().has(CATCHUP_CARDS);
  const isUngatedForDeprecateLegacyTimeline = getGates().has(DEPRECATE_LEGACY_TIMELINE);
  if (!registry) {
    let registryMap = RegistryOverridesMap;
    if (isUngatedForAssociationCardRedesign) {
      registryMap = Object.assign({}, registryMap, RegistryOverridesMapAssociationRedesign);
    }
    if (isUngatedForCatchupCards) {
      registryMap = Object.assign({}, registryMap, CatchupCardsRegistryMap);
    }
    if (!isUngatedForDeprecateLegacyTimeline) {
      registryMap.RECORD_TIMELINE = {
        CardComponent: RecordTimelineCard,
        lazyLoadedTranslations: undefined,
        loadingComponentProps: DEFAULT_LOADING_COMPONENT_PROPS
      };
    }
    registry = buildGlobalCrmCardRegistry(registryMap);
  }
  return registry;
};